/** Written on logout so other tabs can detect the session ended via the `storage` event. */
export const LOGOUT_BROADCAST_KEY = "quest:logout";
